export default [
  {
    path: '/admin/configuration/menu/menu-index',
    name: 'M020015',
    component: () => import('@/views/admin/configuration/menu/MenuIndex.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/configuration/biz/biz-index',
    name: 'M020004',
    component: () => import('@/views/admin/configuration/biz/BizIndex.vue'),
    meta: { layout: 'admin' },
  },
];
